whenAvailable('$',function() {
$(document).ready(function() {
    var animation_shown = false;

    if ($('.about-animated-map').length > 0) {
        // init animation when on scroll to viewport
        $(window).scroll(function() {
            var top_of_element = $('.about-animated-map').offset().top;
            var bottom_of_element = $('.about-animated-map').offset().top + $('.about-animated-map').outerHeight();
            var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
            var top_of_screen = $(window).scrollTop();

            if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element) && !animation_shown){
                var entityTimeDelay = 250;
                setTimeout(function() {
                    $('#zone-active').addClass('activated');
                    $('#zone-marker').addClass('activated');
                    setTimeout(function() { $('.about-map .white-overlay').css('opacity',1).addClass('active'); }, entityTimeDelay+250);
                }, entityTimeDelay) ;

                animation_shown = true;
            }
        });
    }

    if ($('#timelineCarousel').length > 0 && $('#timelineArrow').length > 0) {
        whenAvailable('slick',function() {
            $('#timelineCarousel')?.slick({
                slidesToShow: 1,
                centerMode: true,
                variableWidth: true,
                infinite: false,
                arrows: false,
                focusOnSelect: true,
                asNavFor: '#timelineArrow',
            }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
                if (currentSlide != nextSlide) {
                    $('#timelineArrow .timeline-dot').addClass('disabled');
                }
            }).on('afterChange', function(){
                $('#timelineArrow .timeline-dot').removeClass('disabled');
            });

            $('#timelineArrow')?.slick({
                infinite: false,
                slidesToShow: 19,
                arrows: false,
                focusOnSelect: true,
                asNavFor: '#timelineCarousel',
            });
        });

        if ($(document).width() < 767) {
            $('#timelineArrow').on('beforeChange', function(event, slick, currentSlide, nextSlide){
                var left_dist = $('.timeline-dot').outerWidth(true)*(nextSlide+.5) - $(document).width()/2 + 40;
                $('.timeline-arrow-wrapper').animate({
                    scrollLeft: left_dist
                }, 500);
            });
        }
    }

    if ($('.infinite-slider').length > 0) {
        var clone = $('.infinite-slider ul').children();

        for (i = 0; i < 10; i++) {
            obj = $(clone[i]).children();
            $('.infinite-slider ul').append( '<li>' + obj.attr('src', obj.attr('data-src')).addClass('lazy-loaded')[0].outerHTML + '</li>' );

            if (i == 9) {
                whenAvailable('lazyload', function(){
                    setTimeout(function() {
                        initLazyload();
                    }, 500);
                });
            }
        }

        $('body').append('<style>'+
            '@keyframes move-left-infinite-mobile { 0% { transform: translate(0, 0); } 100% { transform: translate(-'+(($('.infinite-slider ul').children().length-10) * 220)+'px, 0); } }'+
            '@keyframes move-left-infinite { 0% { transform: translate(0, 0); } 100% { transform: translate(-'+(($('.infinite-slider ul').children().length-10) * 260)+'px, 0); } }'+
            '</style>');
    }

    $('.tab-content .btn-link').each(function(index) {
        $(this).on('click', function(e) {
            e.preventDefault();
            var content_id = $(this).attr('href');
            $('#event_tabs a[href="'+ content_id +'"]').tab('show');
        });
    });

    $('#event_tabs a[data-bs-toggle="tab"]').on('show.bs.tab', function (e) {
        var index = $(e.target).parent().index() + 1;
        $('.about-event-img').hide();
        $('#event_img_' + index).fadeIn();
    });

    if ($('#eventsCarousel').length > 0) {
        whenAvailable('slick',function() {
            $('#eventsCarousel')?.slick({
                slidesToShow: 1,
                centerMode: true,
                variableWidth: true,
                infinite: false,
                arrows: false,
                focusOnSelect: true,
            });
        });
    }
});
});
